import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatSnackBar, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { UsersService } from '../../../services/users/users.service';
import { ResourceService } from '../../../services/resource/resource.service';
import { NotifierService } from 'angular-notifier';
import { TokenStorage } from 'src/app/auth/token.storage';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-edituser',
  templateUrl: './edituser.component.html',
  styleUrls: ['./edituser.component.scss']
})
export class EdituserComponent implements OnInit {

  userForm: FormGroup;
  name: string;
  associatedUnit: any;
  selectedAssociatedUnit: string;
  isAssociatedUnit: boolean = true;
  allBranchesNames = [];
  isTenantDiag: boolean = true;
  isResource: boolean = true;
  isDriver: boolean = false;
  allRoles = [];
  alreadySelectedBranches = [];
  alreadySelectedRoles = [];

  constructor(
    private userService: UsersService,
    public formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    public resourceService: ResourceService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notifierService: NotifierService,
    private dialogRef: MatDialogRef<EdituserComponent>,
    private token: TokenStorage,
    private datePipe: DatePipe
  ) {
    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
    }
    else {
      this.isTenantDiag = false;
    }

    this.createUserForm();

  }

  ngOnInit() {
    console.log(this.data);
    this.userService.getAllRoles().subscribe(roles => {
      this.allRoles = roles;
    })

    this.resourceService.getBranches().subscribe(allBranches => {
      console.log("branches", allBranches);
      this.allBranchesNames = allBranches;
    });

      this.data.user.roles.forEach(role => {
        this.alreadySelectedRoles.push(role.roleName);
      });

      this.data.user.branchesMapped.forEach(branch => {
        this.alreadySelectedBranches.push(branch.branchName);
      });

      this.userForm.patchValue({
        resourceType: this.data.user.resource.resourceType,
        firstName: this.data.user.resource.firstName,
        lastName: this.data.user.resource.lastName,
        emailId: this.data.user.resource.emailId,
        phoneNumber1: this.data.user.resource.phoneNumber1,
        associatedUnit: this.data.user.resource.associatedUnit,
        designation: this.data.user.resource.designation,
        language: this.data.user.resource.language,
        branchNames: this.alreadySelectedBranches,
        roles: this.alreadySelectedRoles,
        username: this.data.user.username,
        dateOfBirth: this.data.user.resource.dateOfBirth,
        governmentIdType1: this.data.user.resource.governmentIdType1,
        governmentIdNumber1: this.data.user.resource.governmentIdNumber1,
        gender: this.data.user.resource.gender
      })
  }

  createUserForm() {
      this.userForm = this.formBuilder.group({
        'firstName': [null, [
          Validators.required,
          Validators.pattern("^[a-zA-Z_ ]+$")
        ]],
        'lastName': [null, [
          Validators.pattern("^[a-zA-Z_ ]+$")
        ]],
        'gender': [null],
        'phoneNumber1': [null, [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern('^[0-9]*$')
        ]],
        'emailId': [null, Validators.email
        ],
        'dateOfBirth': [null],
        'governmentIdType1': [null],
        'governmentIdNumber1': [null, [Validators.pattern("^[a-zA-Z0-9_ ]+$")]],
        'resourceType': [null],
        'designation': [null],
        'language': [null],
        'branchNames': [null, [
          Validators.required]],
        'roles': [null, [
          Validators.required]],
        'username': [null, [
          Validators.required,
          Validators.pattern("^[a-zA-Z0-9_@]+$")
        ]],
        'password': [null,
          [Validators.minLength(8),
          Validators.maxLength(20)]]
      });
  }

  onSelectResource(resource) {
    this.isResource = true;
    if (resource === 'driver')
      this.isDriver = true;
    else
      this.isDriver = false;
  }


  selectBirthDate(event) {
    let date = new Date(event.value);
    console.log(this.datePipe.transform(date, 'yyyy-MM-dd'))
    this.userForm.value.dateOfBirth = this.datePipe.transform(date, 'yyyy-MM-dd');
  }


  editResourceUser() {
    let roles = [];
    this.allRoles.forEach(roleObj => {
      this.alreadySelectedRoles.forEach(role => {
        if (role == roleObj.roleName) {
          roles.push(roleObj);
        }
      });
    });

    this.userForm.value.roles = roles;

    this.userForm.value.resource = {
      firstName: this.userForm.value.firstName,
      lastName: this.userForm.value.lastName,
      phoneNumber1: this.userForm.value.phoneNumber1,
      emailId: this.userForm.value.emailId,
      address: null,
      dateOfBirth: this.userForm.value.dateOfBirth,
      designation: this.userForm.value.designation,
      gender: this.userForm.value.gender,
      governmentIdNumber1: this.userForm.value.governmentIdNumber1,
      governmentIdType1: this.userForm.value.governmentIdType1,
      language: this.userForm.value.language,
      resourceType: this.userForm.value.resourceType
    }

    delete this.userForm.value.firstName;
    delete this.userForm.value.lastName;
    delete this.userForm.value.phoneNumber1;
    delete this.userForm.value.emailId;
    delete this.userForm.value.dateOfBirth,
    delete this.userForm.value.designation,
    delete this.userForm.value.gender,
    delete this.userForm.value.governmentIdNumber1,
    delete this.userForm.value.governmentIdType1,
    delete this.userForm.value.language,
    delete this.userForm.value.resourceType

    console.log(this.userForm.value);
    this.userService.updateUserAndResource(this.userForm.value).subscribe(res => {
      this.notifierService.notify('success', "User saved successfully.");
      this.dialogRef.close('true');
    }, error => {
      this.notifierService.notify('error', "Error updating user.");
    })
  }

  onSelectAssociatedUnit() {
    this.isAssociatedUnit = true;
  }
}
